// ============================================
// 📱 FORMULÁRIO WHATSAPP MULTI-IDS - formwhatsapp-multi.js
// Form ID: 515419
// Suporta múltiplos containers em diferentes páginas
// ============================================

(function initWhatsappFormModalMulti() {
  console.log("🟢 [WHATSAPP MULTI] Inicializando formulário WhatsApp multi-IDs");
  
  // ==========================================
  // 🎯 ADICIONE TODOS OS IDs DE CONTAINERS AQUI
  // ==========================================
  const CONTAINER_IDS = [
    "#AcHdwV2U0SUY5QmZje__forms_inline_Jc3pzi",  // home
    "#AU3c2eFMrdkljSEdSO__forms_inline_UXKzJ3",  // pages/agende-sua-visita
    "#Ac2N2RjVTSTNhbmF1d__forms_inline_j3xnwB",  // pages/quem-somos
    "#AN0RDT2VxbUJEejN4S__forms_inline_9mqCq4",  // collections/acessorios
    "#AZDB2aVhYVDg4ckRYd__forms_inline_MUWFEh",  // collections/acessorios >> produtos
    "#ATHU3K1ZmNVUwRW9qe__forms_inline_6Kd6WD",  // collections >> vestidos de noiva
    "#ANDJKQzFzQTR4Uk1Pc__forms_inline_MdmHeU",  // collections >> produtos 
    "#ATmdZYnlOZEtLTXJRV__forms_inline_GEzwNU",  // pages/blog
    "#AS1NCb0tsazRXcEttM__forms_inline_RY4MpT",  // pages/blog >> paginas 
    "#WhatsappModal_FormsEmbed"
    // Adicione mais IDs conforme necessário:
    // "#OUTRO_ID_AQUI",
    // "#MAIS_UM_ID",
  ];

  const COOKIE_NAME_WHATSAPP = "utm_campaign_whatsapp";
  const COOKIE_DAYS = 30;
  const FORM_ID = "515419";

  // Controle de processamento
  const processedForms = new WeakSet();
  let modalCreated = false;
  let buttonCreated = false;

  // ==========================================
  // 🔧 FUNÇÕES AUXILIARES - UTM
  // ==========================================
  function getCookie(name) {
    const b = document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)');
    return b ? decodeURIComponent(b.pop()) : "";
  }

  function setCookie(name, value, days) {
    if (!value) return;
    const d = new Date();
    d.setTime(d.getTime() + (days * 24 * 60 * 60 * 1000));
    document.cookie = `${name}=${encodeURIComponent(value)}; expires=${d.toUTCString()}; path=/`;
  }

  function getUTMValue() {
    const params = new URLSearchParams(window.location.search);
    let utmValue = "";
    
    if (params.get("utm_campaign_whatsapp")) {
      utmValue = params.get("utm_campaign_whatsapp");
      setCookie(COOKIE_NAME_WHATSAPP, utmValue, COOKIE_DAYS);
      console.log("🟢 [WHATSAPP MULTI] ✅ UTM WhatsApp capturado da URL:", utmValue);
    } else if (params.get("utm_campaign")) {
      utmValue = params.get("utm_campaign");
      setCookie(COOKIE_NAME_WHATSAPP, utmValue, COOKIE_DAYS);
      console.log("🟢 [WHATSAPP MULTI] ✅ UTM genérico capturado da URL:", utmValue);
    } else if (getCookie(COOKIE_NAME_WHATSAPP)) {
      utmValue = getCookie(COOKIE_NAME_WHATSAPP);
      console.log("🟢 [WHATSAPP MULTI] ✅ UTM WhatsApp recuperado do cookie:", utmValue);
    } else if (getCookie("utm_campaign")) {
      utmValue = getCookie("utm_campaign");
      setCookie(COOKIE_NAME_WHATSAPP, utmValue, COOKIE_DAYS);
      console.log("🟢 [WHATSAPP MULTI] ✅ UTM genérico usado como fallback:", utmValue);
    } else {
      console.log("🟢 [WHATSAPP MULTI] ⚠️ Nenhum UTM encontrado");
    }
    
    return utmValue;
  }

  // ==========================================
  // 🎨 CRIAR ESTILOS GLOBAIS
  // ==========================================
  function createGlobalStyles() {
    

    if (document.getElementById('whatsapp-multi-styles')) return;
    
    const styleSheet = document.createElement("style");
    styleSheet.id = 'whatsapp-multi-styles';
    
    // Cria regras para cada container
    let hideRules = CONTAINER_IDS.map(id => `${id} { display: none; }`).join('\n    ');
    let showRules = CONTAINER_IDS.map(id => `#modal-form-container ${id} { display: block !important; }`).join('\n    ');
    
    styleSheet.innerText = `
    ${hideRules}
    ${showRules}
    
    @keyframes fadeIn {
      from { opacity: 0; }
      to { opacity: 1; }
    }
    
    @keyframes pulse {
      0%, 100% { transform: scale(1); }
      50% { transform: scale(1.05); }
    }
    
    #whatsapp-floating-btn:hover {
      transform: scale(1.1) !important;
      box-shadow: 0 6px 25px rgba(37, 211, 102, 0.6) !important;
    }
    
    @media (max-width: 768px) {
      #whatsapp-floating-btn {
        right: 1rem !important;
        width: 44px !important;
        height: 44px !important;
      }
      #whatsapp-modal-content {
        padding: 15px !important;
        width: 95% !important;
      }
    }
  `;
    document.head.appendChild(styleSheet);
    console.log("✅ [WHATSAPP MULTI] Estilos globais aplicados para", CONTAINER_IDS.length, "container(s)");
  }

  // ==========================================
  // 🎨 CRIAR BOTÃO FLUTUANTE
  // ==========================================
  function createFloatingButton() {
    if (buttonCreated || document.getElementById('whatsapp-floating-btn')) {
      return;
    }
    
    const floatingBtn = document.createElement('div');
    floatingBtn.id = 'whatsapp-floating-btn';
    floatingBtn.innerHTML = `
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width="37px" height="37px" fill-rule="evenodd" clip-rule="evenodd">
        <path fill="#fff" d="M4.868,43.303l2.694-9.835C5.9,30.59,5.026,27.324,5.027,23.979C5.032,13.514,13.548,5,24.014,5c5.079,0.002,9.845,1.979,13.43,5.566c3.584,3.588,5.558,8.356,5.556,13.428c-0.004,10.465-8.522,18.98-18.986,18.98c-0.001,0,0,0,0,0h-0.008c-3.177-0.001-6.3-0.798-9.073-2.311L4.868,43.303z"/><path fill="#fff" d="M4.868,43.803c-0.132,0-0.26-0.052-0.355-0.148c-0.125-0.127-0.174-0.312-0.127-0.483l2.639-9.636c-1.636-2.906-2.499-6.206-2.497-9.556C4.532,13.238,13.273,4.5,24.014,4.5c5.21,0.002,10.105,2.031,13.784,5.713c3.679,3.683,5.704,8.577,5.702,13.781c-0.004,10.741-8.746,19.48-19.486,19.48c-3.189-0.001-6.344-0.788-9.144-2.277l-9.875,2.589C4.953,43.798,4.911,43.803,4.868,43.803z"/><path fill="#cfd8dc" d="M24.014,5c5.079,0.002,9.845,1.979,13.43,5.566c3.584,3.588,5.558,8.356,5.556,13.428c-0.004,10.465-8.522,18.98-18.986,18.98h-0.008c-3.177-0.001-6.3-0.798-9.073-2.311L4.868,43.303l2.694-9.835C5.9,30.59,5.026,27.324,5.027,23.979C5.032,13.514,13.548,5,24.014,5 M24.014,42.974C24.014,42.974,24.014,42.974,24.014,42.974C24.014,42.974,24.014,42.974,24.014,42.974 M24.014,42.974C24.014,42.974,24.014,42.974,24.014,42.974C24.014,42.974,24.014,42.974,24.014,42.974 M24.014,4C24.014,4,24.014,4,24.014,4C12.998,4,4.032,12.962,4.027,23.979c-0.001,3.367,0.849,6.685,2.461,9.622l-2.585,9.439c-0.094,0.345,0.002,0.713,0.254,0.967c0.19,0.192,0.447,0.297,0.711,0.297c0.085,0,0.17-0.011,0.254-0.033l9.687-2.54c2.828,1.468,5.998,2.243,9.197,2.244c11.024,0,19.99-8.963,19.995-19.98c0.002-5.339-2.075-10.359-5.848-14.135C34.378,6.083,29.357,4.002,24.014,4L24.014,4z"/><path fill="#40c351" d="M35.176,12.832c-2.98-2.982-6.941-4.625-11.157-4.626c-8.704,0-15.783,7.076-15.787,15.774c-0.001,2.981,0.833,5.883,2.413,8.396l0.376,0.597l-1.595,5.821l5.973-1.566l0.577,0.342c2.422,1.438,5.2,2.198,8.032,2.199h0.006c8.698,0,15.777-7.077,15.78-15.776C39.795,19.778,38.156,15.814,35.176,12.832z"/><path fill="#fff" fill-rule="evenodd" d="M19.268,16.045c-0.355-0.79-0.729-0.806-1.068-0.82c-0.277-0.012-0.593-0.011-0.909-0.011c-0.316,0-0.83,0.119-1.265,0.594c-0.435,0.475-1.661,1.622-1.661,3.956c0,2.334,1.7,4.59,1.937,4.906c0.237,0.316,3.282,5.259,8.104,7.161c4.007,1.58,4.823,1.266,5.693,1.187c0.87-0.079,2.807-1.147,3.202-2.255c0.395-1.108,0.395-2.057,0.277-2.255c-0.119-0.198-0.435-0.316-0.909-0.554s-2.807-1.385-3.242-1.543c-0.435-0.158-0.751-0.237-1.068,0.238c-0.316,0.474-1.225,1.543-1.502,1.859c-0.277,0.317-0.554,0.357-1.028,0.119c-0.474-0.238-2.002-0.738-3.815-2.354c-1.41-1.257-2.362-2.81-2.639-3.285c-0.277-0.474-0.03-0.731-0.208-0.968c0.213-0.213,0.474-0.554,0.712-0.831c0.237-0.277,0.316-0.475,0.474-0.791c0.158-0.317,0.079-0.594-0.04-0.831C20.612,19.329,19.69,16.983,19.268,16.045z" clip-rule="evenodd"/>
      </svg>
    `;
    
    floatingBtn.style.cssText = `
      position: fixed;
      bottom: 11rem;
      right: 3rem;
      background-color: #f8f2ed80;
      box-shadow: 0 4px 4px #0000004d;
      min-width: 44px;
      min-height: 44px;
      border-color: #787878;
      border-width: 2px;
      border-style: solid;
      padding: 0;
      margin: 0;
      max-width: 49px;
      max-height: 49px;
      -webkit-backdrop-filter: blur(10px);
      backdrop-filter: blur(10px);
      cursor: pointer;
      transition: all 0.3s ease;
      display: flex;
      justify-content: center;
      align-items: center;
      z-index: 9998;
    `;

    document.body.appendChild(floatingBtn);
    buttonCreated = true;
    console.log("✅ [WHATSAPP MULTI] Botão flutuante criado");

    floatingBtn.addEventListener('click', () => {
      console.log("🎯 [WHATSAPP MULTI] Botão flutuante clicado!");
      console.log("📍 [WHATSAPP MULTI] Página atual:", window.location.pathname);
      openModal();
    });
  }

  // ==========================================
  // 🎨 CRIAR MODAL
  // ==========================================
  function createModal() {
    if (modalCreated || document.getElementById('whatsapp-form-modal')) {
      return;
    }
    
    const modal = document.createElement('div');
    modal.id = 'whatsapp-form-modal';
    modal.style.cssText = `
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.6);
      z-index: 9998;
      backdrop-filter: blur(2px);
      display: none;
      opacity: 0;
      transition: opacity 0.3s ease;
    `;

    // MODAL
    const modalContent = document.createElement('div');
    modalContent.classList.add('whatsapp-modal-content');
    modalContent.id = 'whatsapp-modal-content';
    modalContent.style.cssText = `
      position: fixed;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%) scale(0.9);
      width: 90%;
      max-width: 800px;
      background: #f8f8f8;
      border-radius: 0;
      box-shadow: 0 8px 30px rgba(0, 0, 0, 0.3);
      padding: 30px 50px;
      z-index: 9999;
      transition: transform 0.3s ease;
      max-height: 90vh;
      overflow-y: auto;
    `;

    // HEADER
    const headerContainer = document.createElement('div');
    headerContainer.classList.add('whatsapp-modal-header');
    headerContainer.style.cssText = `
      position: relative;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding-bottom: 50px;
    `;

    // LOGO
    const logoContainer = document.createElement('div');
    logoContainer.classList.add('whatsapp-modal-logo');
    logoContainer.innerHTML = `
      <svg xmlns="http://www.w3.org/2000/svg" width="207" height="51" viewBox="0 0 207 51" fill="none">
      <g clip-path="url(#clip0_4565_1682)">
      <path d="M69.4784 6.46793C69.4784 3.06808 69.9101 1.39572 72.1059 -0.000976562H66.1753C67.245 0.660616 67.8832 1.37734 68.2397 2.27784C68.6714 3.34374 68.7277 4.64855 68.7277 6.46793V9.15106L68.7465 38.739L40.8387 0.017401H32.3182C34.2888 1.2487 34.7955 2.75566 34.9081 3.87669V30.2853C32.0742 26.1319 26.35 23.945 19.0869 23.504C27.6074 22.8056 33.4255 19.4058 33.4255 12.2385C33.4442 3.08646 26.1248 0.017401 14.4887 0.017401H0C2.55242 1.68976 2.62749 3.14159 2.62749 6.48631V44.583C2.62749 47.6521 2.55242 49.3796 0 50.9784H16.6846C30.1786 50.9784 36.8412 45.1344 36.8412 36.938C36.8412 34.8613 36.4095 33.0603 35.6025 31.4798V3.72967L69.1594 50.9784H69.8725L69.4409 39.713V6.46793H69.4784ZM9.79679 0.440085H14.4887C24.4357 0.440085 26.2749 5.5123 26.2749 12.2569C26.2749 18.1745 23.7225 23.5223 14.8453 23.5223H9.79679V0.440085ZM16.4031 50.6476H9.79679V23.8715H16.4031C26.4063 23.8715 28.9775 30.1383 28.9775 36.938C28.9775 42.8555 28.1892 50.6293 16.4031 50.6293V50.6476Z" fill="#020202"/>
      <path d="M87.5715 12.4411C87.5715 12.4411 87.5715 12.3493 87.6278 12.3493C88.097 12.3493 89.073 12.3125 89.7861 12.3125C92.2823 12.3125 92.6388 13.6724 92.6388 14.4075C92.6388 15.3448 92.0946 15.8594 91.7568 16.0983C92.2635 16.3188 93.0705 16.8701 93.0705 18.0279C93.0705 19.6452 91.6254 20.4538 89.7486 20.4538C88.904 20.4538 88.1158 20.4538 87.6466 20.4354C87.5903 20.4354 87.5715 20.3986 87.5715 20.3435V12.4411ZM88.6038 15.7124H89.7674C90.2553 15.7124 90.7433 15.7491 90.9497 15.7859C91.3063 15.547 91.6442 15.1794 91.6442 14.5362C91.6442 13.6173 90.9497 13.1946 89.7486 13.1946C89.3357 13.1946 88.8477 13.1946 88.6038 13.213V15.7124ZM88.6038 19.5533C88.8853 19.5533 89.2794 19.5716 89.6735 19.5716C91.0623 19.59 92.0195 19.1122 92.0195 18.0463C92.0195 17.3847 91.6441 16.8885 90.8747 16.6864C90.5931 16.6129 90.2553 16.5945 89.88 16.5945H88.6038V19.5349V19.5533Z" fill="#020202"/>
      <path d="M105.739 20.365C105.739 20.365 105.701 20.4385 105.645 20.4385H100.897C100.897 20.4385 100.803 20.4201 100.803 20.3466V12.4259C100.803 12.4259 100.822 12.334 100.897 12.334H105.457C105.457 12.334 105.532 12.334 105.551 12.4075L105.645 13.1794C105.645 13.1794 105.645 13.2712 105.589 13.2712H101.854V15.8257H105.232C105.232 15.8257 105.307 15.8441 105.307 15.8992V16.6895C105.307 16.6895 105.269 16.763 105.232 16.763H101.854V19.5012H105.833C105.833 19.5012 105.908 19.5196 105.889 19.5748L105.757 20.365H105.739Z" fill="#020202"/>
      <path d="M113.509 20.4385C113.509 20.4385 113.415 20.4017 113.415 20.3466V12.4259C113.415 12.4259 113.415 12.334 113.49 12.334H114.391C114.391 12.334 114.447 12.3524 114.447 12.4075V19.5012H118.332C118.332 19.5012 118.407 19.538 118.388 19.5748L118.238 20.365C118.238 20.365 118.182 20.4385 118.144 20.4385H113.509Z" fill="#020202"/>
      <path d="M127.171 17.8824L126.27 20.3634C126.27 20.3634 126.233 20.4369 126.177 20.4369H125.332C125.332 20.4369 125.238 20.4001 125.257 20.345L127.978 12.9205C128.016 12.8286 128.053 12.7367 128.072 12.4243C128.072 12.3875 128.091 12.3691 128.128 12.3691H129.348C129.348 12.3691 129.405 12.3691 129.423 12.4243L132.37 20.3818C132.37 20.3818 132.37 20.4737 132.314 20.4737H131.356C131.356 20.4737 131.281 20.4553 131.263 20.4185L130.343 17.9375H127.171V17.8824ZM130.061 16.9452C129.78 16.1549 128.992 14.0047 128.766 13.1778C128.56 13.968 127.959 15.6036 127.471 16.9452H130.08H130.061Z" fill="#020202"/>
      <path d="M148.942 20.4385C148.942 20.4385 148.848 20.4385 148.848 20.3466V12.4075C148.848 12.4075 148.848 12.334 148.923 12.334H150.162C150.162 12.334 150.237 12.3524 150.275 12.4075C151.363 14.2085 153.765 18.1964 154.272 19.1521C154.253 18.8213 154.235 18.3618 154.235 17.2959V12.4259C154.235 12.4259 154.253 12.334 154.328 12.334H155.154C155.154 12.334 155.248 12.3707 155.248 12.4259V20.3466C155.248 20.3466 155.229 20.4385 155.135 20.4385H154.028C154.028 20.4385 153.915 20.4385 153.897 20.365C153.334 19.3358 150.218 14.282 149.824 13.3815C149.843 13.8593 149.88 14.4658 149.88 15.5317V20.365C149.88 20.365 149.862 20.4569 149.805 20.4569H148.98L148.942 20.4385Z" fill="#020202"/>
      <path d="M170.525 16.3391C170.525 18.9671 168.949 20.5475 166.791 20.5475C164.407 20.5475 163 18.7649 163 16.3574C163 13.95 164.595 12.2041 166.772 12.2041C169.118 12.2041 170.525 14.0235 170.544 16.3391H170.525ZM166.809 19.6286C168.48 19.6286 169.456 18.3055 169.456 16.3574C169.456 14.4645 168.386 13.123 166.753 13.123C165.252 13.123 164.069 14.2624 164.069 16.3574C164.069 18.1401 165.026 19.6286 166.828 19.6286H166.809Z" fill="#020202"/>
      <path d="M179.308 20.3466C179.308 20.3466 179.308 20.4385 179.233 20.4385H178.351C178.351 20.4385 178.257 20.4201 178.257 20.3466V12.4259C178.257 12.4259 178.276 12.334 178.332 12.334H179.214C179.214 12.334 179.29 12.3524 179.29 12.4075V20.3466H179.308Z" fill="#020202"/>
      <path d="M190.419 19.4277C190.682 18.564 191.32 16.616 192.878 12.4075C192.878 12.3524 192.915 12.334 192.972 12.334H193.891C193.891 12.334 193.966 12.3524 193.947 12.4259L190.963 20.365C190.963 20.365 190.907 20.4385 190.851 20.4385H189.856C189.856 20.4385 189.762 20.4385 189.744 20.3834L186.703 12.4259C186.703 12.4259 186.703 12.334 186.759 12.334H187.717C187.717 12.334 187.792 12.334 187.81 12.3891C189.256 16.1381 190.156 18.6191 190.382 19.4277H190.4H190.419Z" fill="#020202"/>
      <path d="M201.661 17.8824L200.76 20.3634C200.76 20.3634 200.723 20.4369 200.666 20.4369H199.822C199.822 20.4369 199.728 20.4001 199.747 20.345L202.468 12.9205C202.505 12.8286 202.543 12.7367 202.562 12.4243C202.562 12.3875 202.581 12.3691 202.618 12.3691H203.838C203.838 12.3691 203.894 12.3691 203.913 12.4243L206.86 20.3818C206.86 20.3818 206.86 20.4737 206.803 20.4737H205.846C205.846 20.4737 205.771 20.4553 205.752 20.4185L204.833 17.9375H201.661V17.8824ZM204.551 16.9452C204.27 16.1549 203.481 14.0047 203.256 13.1778C203.05 13.968 202.449 15.6036 201.961 16.9452H204.57H204.551Z" fill="#020202"/>
      <path d="M121.691 38.6126V38.5023C122.554 38.3553 122.836 38.1899 122.892 37.0505C122.911 36.591 122.93 35.7089 122.93 34.9922C122.93 34.349 122.93 33.7058 122.911 33.1361C122.873 31.9415 122.761 31.6842 121.86 31.5372V31.4453H123.305C123.812 31.4453 124.356 31.4453 124.956 31.4453C125.97 31.4453 126.852 31.4821 127.622 31.9783C128.56 32.5847 129.198 33.5771 129.198 34.9738C129.198 37.7121 127.284 38.6677 125.613 38.6677C124.675 38.6677 123.924 38.6309 123.474 38.6309H121.672L121.691 38.6126ZM124.018 33.0993V34.9554C124.018 35.8008 124.018 36.7932 124.018 37.2343C124.037 38.2083 124.431 38.5023 125.05 38.5023C125.707 38.5023 126.233 38.392 126.946 37.6937C127.528 37.1056 127.884 36.1867 127.884 34.9922C127.884 33.375 126.833 31.5556 124.694 31.5556C124.544 31.5556 124.206 31.5556 124.056 31.574C124.037 31.9415 124.018 32.5112 124.018 33.0993Z" fill="black"/>
      <path d="M134.34 37.4742C134.303 38.0071 133.758 38.7606 132.52 38.7606C130.943 38.7606 130.099 37.7498 130.099 36.445C130.099 35.2137 130.887 33.9824 132.445 33.9824C133.627 33.9824 134.265 34.7543 134.321 35.5997H131.131C131.093 35.8202 131.093 36.0591 131.093 36.3164C131.093 38.0071 132.163 38.4298 132.82 38.4298C133.665 38.4298 134.115 37.952 134.228 37.4374L134.359 37.4742H134.34ZM133.458 35.4526C133.439 34.791 133.083 34.1294 132.426 34.1294C131.769 34.1294 131.337 34.6256 131.168 35.4526H133.458Z" fill="black"/>
      <path d="M135.129 38.7594L135.035 37.1606H135.148C135.298 37.8038 135.767 38.6124 136.536 38.6124C136.987 38.6124 137.475 38.3551 137.475 37.8222C137.475 37.3995 137.212 37.0319 136.367 36.6276C135.617 36.2601 135.223 35.819 135.223 35.2126C135.223 34.6061 135.842 33.9629 136.668 33.9629C137.024 33.9629 137.437 34.1467 137.569 34.1467C137.681 34.1467 137.719 34.0732 137.756 33.9996H137.85L137.944 35.3228H137.831C137.662 34.845 137.343 34.1099 136.649 34.1099C136.142 34.1099 135.861 34.5142 135.861 34.7899C135.861 35.2493 136.086 35.5434 136.912 35.9293C137.775 36.3152 138.225 36.7195 138.225 37.4363C138.225 38.153 137.644 38.7594 136.555 38.7594C136.011 38.7594 135.635 38.5205 135.485 38.5205C135.373 38.5205 135.298 38.6308 135.223 38.7594H135.148H135.129Z" fill="black"/>
      <path d="M142.823 38.741H142.786L142.71 38.1897C142.354 38.5756 141.791 38.7594 141.34 38.7594C139.97 38.7594 139.032 37.8405 139.032 36.3887C139.032 34.9369 140.158 33.9812 141.378 33.9812C142.054 33.9812 142.429 34.2018 142.729 34.5326V32.4927C142.729 31.5922 142.429 31.4635 141.885 31.4268V31.3165L143.555 31.2246H143.593C143.593 31.7392 143.574 32.4559 143.574 32.8602V37.326C143.574 37.914 143.574 38.4286 144.362 38.447V38.5389L142.823 38.7227V38.741ZM142.748 36.4622C142.748 35.7823 142.692 35.2493 142.56 34.9001C142.335 34.3304 141.922 34.1466 141.472 34.1466C140.608 34.1466 140.045 35.2677 140.045 36.3703C140.045 37.5465 140.571 38.6124 141.509 38.6124C141.997 38.6124 142.391 38.3184 142.598 37.767C142.729 37.4546 142.748 36.9952 142.748 36.4622Z" fill="black"/>
      <path d="M149.279 37.4742C149.242 38.0071 148.698 38.7606 147.459 38.7606C145.882 38.7606 145.038 37.7498 145.038 36.445C145.038 35.2137 145.826 33.9824 147.384 33.9824C148.566 33.9824 149.204 34.7543 149.261 35.5997H146.07C146.033 35.8202 146.033 36.0591 146.033 36.3164C146.033 38.0071 147.102 38.4298 147.759 38.4298C148.604 38.4298 149.054 37.952 149.167 37.4374L149.298 37.4742H149.279ZM148.397 35.4526C148.379 34.791 148.022 34.1294 147.365 34.1294C146.708 34.1294 146.277 34.6256 146.108 35.4526H148.397Z" fill="black"/>
      <path d="M153.052 38.6123V38.502C153.465 38.502 153.802 38.4285 153.953 38.2264C154.122 37.9875 154.197 37.6934 154.197 37.1789V32.805C154.197 32.6028 154.159 32.2353 154.14 32.125C153.99 32.1618 153.859 32.1802 153.671 32.1802C153.483 32.1802 153.258 32.1434 153.127 32.1066V32.0148C153.99 31.978 154.553 31.7391 155.004 31.3164H155.06C155.022 31.7575 155.022 32.1801 155.022 32.5477V37.1789C155.022 37.7302 155.06 38.0058 155.21 38.208C155.341 38.3734 155.642 38.4837 155.98 38.4837V38.5939H153.071L153.052 38.6123Z" fill="black"/>
      <path d="M159.039 36.1861C157.744 36.1861 156.787 35.2672 156.787 33.944C156.787 32.6209 157.856 31.4814 159.114 31.4814C160.465 31.4814 161.404 32.6392 161.404 34.5505C161.404 37.2153 159.883 38.7773 158.269 38.7773C157.331 38.7773 156.993 38.3547 156.993 38.0239C156.993 37.785 157.162 37.5828 157.425 37.5828C157.744 37.5828 157.838 37.8033 157.969 38.1709C158.063 38.4466 158.251 38.5752 158.588 38.5752C159.339 38.5752 160.202 37.6747 160.465 35.598C160.221 35.8921 159.808 36.1861 159.076 36.1861H159.039ZM160.428 33.8522C160.428 32.6025 159.846 31.6468 159.076 31.6468C158.307 31.6468 157.763 32.4922 157.763 33.9073C157.763 35.1018 158.288 36.0575 159.076 36.0575C160.052 36.0575 160.428 34.771 160.428 33.8522Z" fill="black"/>
      <path d="M164.781 36.1861C163.486 36.1861 162.529 35.2672 162.529 33.944C162.529 32.6209 163.599 31.4814 164.857 31.4814C166.208 31.4814 167.146 32.6392 167.146 34.5505C167.146 37.2153 165.626 38.7773 164.012 38.7773C163.074 38.7773 162.736 38.3547 162.736 38.0239C162.736 37.785 162.905 37.5828 163.167 37.5828C163.486 37.5828 163.58 37.8033 163.712 38.1709C163.806 38.4466 163.993 38.5752 164.331 38.5752C165.082 38.5752 165.945 37.6747 166.208 35.598C165.964 35.8921 165.551 36.1861 164.819 36.1861H164.781ZM166.17 33.8522C166.17 32.6025 165.588 31.6468 164.819 31.6468C164.049 31.6468 163.505 32.4922 163.505 33.9073C163.505 35.1018 164.031 36.0575 164.819 36.0575C165.795 36.0575 166.17 34.771 166.17 33.8522Z" fill="black"/>
      <path d="M169.342 33.4844C169.23 33.5579 169.136 33.5763 169.023 33.5763C168.61 33.5763 168.31 33.2088 168.348 32.7493C168.385 32.0326 169.117 31.4629 170.149 31.4629C171.369 31.4629 172.139 32.1429 172.139 33.2271C172.139 34.0541 171.594 34.6973 170.487 34.8811C171.557 35.0098 172.326 35.6346 172.326 36.6637C172.326 37.8767 171.275 38.7772 169.755 38.7772C168.479 38.7772 167.766 38.0972 167.766 37.454C167.766 37.1232 167.954 36.8659 168.235 36.8659C168.573 36.8659 168.723 37.0497 168.723 37.4172C168.723 37.4907 168.723 37.5459 168.723 37.6745C168.723 38.2442 169.098 38.6485 169.755 38.6485C170.75 38.6485 171.369 37.8583 171.369 36.7373C171.369 35.6162 170.9 35.0649 170.375 35.0649C170.074 35.0649 169.943 35.3589 169.511 35.3589C169.305 35.3589 169.136 35.267 169.136 35.0833C169.136 34.8627 169.324 34.7525 169.586 34.7525C169.812 34.7525 169.943 34.8627 170.131 34.8627C170.694 34.8627 171.257 34.1276 171.257 33.2088C171.257 32.1429 170.806 31.6467 170.093 31.6467C169.493 31.6467 169.061 32.1061 169.061 32.6391C169.061 33.0985 169.173 33.3006 169.342 33.4477V33.5028V33.4844Z" fill="black"/>
      </g>
      <defs>
      <clipPath id="clip0_4565_1682">
      <rect width="206.859" height="50.9794" fill="white"/>
      </clipPath>
      </defs>
      </svg>
    `;
    logoContainer.style.cssText = `display: flex; align-items: center;`;

    const closeBtn = document.createElement('button');
    closeBtn.innerHTML = '×';
    closeBtn.style.cssText = `
      background: transparent;
      border: none;
      font-size: 40px;
      color: #666;
      cursor: pointer;
      width: 40px;
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 50%;
      transition: all 0.3s ease;
      line-height: 1;
      flex-shrink: 0;
    `;

    closeBtn.addEventListener('mouseenter', () => {
      closeBtn.style.background = '#f0f0f0';
      closeBtn.style.color = '#000';
    });

    closeBtn.addEventListener('mouseleave', () => {
      closeBtn.style.background = 'transparent';
      closeBtn.style.color = '#666';
    });

    closeBtn.addEventListener('click', () => {
      console.log("❌ [WHATSAPP MULTI] Modal fechado pelo botão X");
      closeModal();
    });

    headerContainer.appendChild(logoContainer);
    headerContainer.appendChild(closeBtn);

    const modalTitle = document.createElement('div');
    modalTitle.innerHTML = `
      <h2 style="
        font-size: 2.5rem;
        font-weight: 400;
        margin-bottom: 8px;
        text-align: center;
        font-family: 'Montserrat', sans-serif;
        color: #333;
        letter-spacing: 0.5px;
      ">Preencha os campos</h2>
      <p style="
        font-size: 1.85rem;
        color: #666;
        font-family: 'Montserrat', sans-serif;
        text-align: center;
        margin-bottom: 30px;
        line-height: 1.5;
      ">Em seguida, você será redirecionado(a) para o WhatsApp.</p>
    `;

    const formContainer = document.createElement('div');
    formContainer.id = 'modal-form-container';
    formContainer.style.cssText = `padding: 0;`;

    modalContent.appendChild(headerContainer);
    modalContent.appendChild(modalTitle);
    modalContent.appendChild(formContainer);
    modal.appendChild(modalContent);
    document.body.appendChild(modal);

    modalCreated = true;
    console.log("✅ [WHATSAPP MULTI] Modal criado");

    modal.addEventListener('click', (e) => {
      if (e.target === modal) {
        console.log("❌ [WHATSAPP MULTI] Modal fechado ao clicar fora");
        closeModal();
      }
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && modal.style.display === 'flex') {
        console.log("❌ [WHATSAPP MULTI] Modal fechado com ESC");
        closeModal();
      }
    });
  }

  // ==========================================
  // 🔍 BUSCAR CONTAINER DISPONÍVEL
  // ==========================================
  function findAvailableContainer() {
    for (let containerId of CONTAINER_IDS) {
      const container = document.querySelector(containerId);
      if (container) {
        console.log("✅ [WHATSAPP MULTI] Container encontrado:", containerId);
        return { container, containerId };
      }
    }
    console.log("⚠️ [WHATSAPP MULTI] Nenhum container encontrado ainda");
    return { container: null, containerId: null };
  }

  // ==========================================
  // 🚀 ABRIR MODAL
  // ==========================================
  function openModal() {
    const modal = document.getElementById('whatsapp-form-modal');
    const formContainer = document.getElementById('modal-form-container');

    if (!modal || !formContainer) {
      console.log("⚠️ [WHATSAPP MULTI] Modal ou container não encontrado, criando...");
      createModal();
      setTimeout(() => openModal(), 100);
      return;
    }

    const { container, containerId } = findAvailableContainer();
    
    if (!container) {
      console.log("⚠️ [WHATSAPP MULTI] Nenhum container do formulário encontrado na página");
      console.log("⚠️ [WHATSAPP MULTI] Aguardando formulário carregar...");
      
      setTimeout(() => {
        const { container: retryContainer } = findAvailableContainer();
        if (retryContainer && !formContainer.contains(retryContainer)) {
          formContainer.appendChild(retryContainer);
          console.log("✅ [WHATSAPP MULTI] Formulário movido para o modal (retry)");
        }
      }, 500);
    } else {
      if (!formContainer.contains(container)) {
        formContainer.appendChild(container);
        console.log("✅ [WHATSAPP MULTI] Formulário movido para o modal");
        console.log("📦 [WHATSAPP MULTI] Container usado:", containerId);
      }
    }

    console.log("🟢 [WHATSAPP MULTI] Abrindo modal...");
    console.log("📍 [WHATSAPP MULTI] Página:", window.location.pathname);

    modal.style.display = 'flex';
    setTimeout(() => {
      modal.style.opacity = '1';
      const modalContent = document.getElementById('whatsapp-modal-content');
      if (modalContent) {
        modalContent.style.transform = 'translate(-50%, -50%) scale(1)';
      }
    }, 10);

    document.body.style.overflow = 'hidden';

    setTimeout(() => processAllForms(), 100);

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      'event': 'whatsapp_modal_opened',
      'form_id': FORM_ID,
      'page_url': window.location.href,
      'container_id': containerId
    });
  }

  // ==========================================
  // ❌ FECHAR MODAL
  // ==========================================
  function closeModal() {
    const modal = document.getElementById('whatsapp-form-modal');
    const modalContent = document.getElementById('whatsapp-modal-content');

    if (!modal) return;

    console.log("🟢 [WHATSAPP MULTI] Fechando modal...");

    modal.style.opacity = '0';
    if (modalContent) {
      modalContent.style.transform = 'translate(-50%, -50%) scale(0.9)';
    }

    setTimeout(() => {
      modal.style.display = 'none';
      document.body.style.overflow = '';
    }, 300);

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      'event': 'whatsapp_modal_closed',
      'form_id': FORM_ID,
      'page_url': window.location.href
    });
  }

  // ==========================================
  // 🎨 PROCESSAR FORMULÁRIO
  // ==========================================
  function processWhatsappForm(container, containerId) {
    const isMobile = window.innerWidth <= 768;
    if (!container) return false;

    const shadow = container.querySelector('shopify-forms-embed')?.shadowRoot;
    if (!shadow) return false;

    const form = shadow.querySelector('form');
    if (!form || processedForms.has(form)) return false;

    console.log("✅ [WHATSAPP MULTI] Processando formulário WhatsApp");
    console.log("📦 [WHATSAPP MULTI] Container:", containerId);
    console.log("📍 [WHATSAPP MULTI] Página:", window.location.pathname);

    let formStarted = false;
    const utmValue = getUTMValue();

    // Inputs
    const allInputs = shadow.querySelectorAll('input');
    console.log(`🟢 [WHATSAPP MULTI] ${allInputs.length} inputs encontrados`);

    allInputs.forEach((input) => {
      input.addEventListener('focus', () => {
        if (!formStarted) {
          formStarted = true;
          
          console.log("🎯 [WHATSAPP MULTI] USUÁRIO COMEÇOU A PREENCHER!");
          
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            'event': 'initiate_form',
            'form_id': FORM_ID,
            'form_type': 'whatsapp_modal',
            'page_url': window.location.href,
            'container_id': containerId,
            'timestamp': new Date().getTime()
          });
        }
      }, { once: true });

      input.style.cssText += `
        color: rgb(166, 166, 166) !important;
        background: transparent !important;
        font-size: 15px !important;
        border: 1px solid rgb(149, 149, 149) !important;
        border-radius: 10px !important;
        box-sizing: border-box !important;
        font-family: Montserrat !important;
        transition: 0.3s !important;
      `;

      input.addEventListener('focus', () => {
        input.style.borderColor = "#128c7e !important";
        input.style.boxShadow = "0 0 0 3px rgba(37, 211, 102, 0.1) !important";
      });

      input.addEventListener('blur', () => {
        input.style.borderColor = "#25d366 !important";
        input.style.boxShadow = "none !important";
      });
    });

    // Labels
    const allLabels = shadow.querySelectorAll('label');

      const baseLabelStyles = `
        font-family: Montserrat !important;
        font-size: 14px !important;
        color: #A6A6A6 !important;
        font-weight: 500 !important;
      `;

      const floatingLabels = [
        'label-phone_number',
        'label-email',
        'label-first_name'
      ];

      allLabels.forEach(label => {
        // estilos base
        label.style.cssText += baseLabelStyles;

        const labelFor = label.getAttribute('for');

        // estilos específicos
        if (floatingLabels.includes(labelFor)) {
          console.log('passou:', labelFor);

          label.style.cssText += `
            top: calc(100% - 27px) !important;
            transform: translateY(-17px) !important;
          `;
        }
      });


      // Wrapper
    const wrapper = shadow.querySelector('[data-sizing="form-wrapper"]');
    if (wrapper) {
      wrapper.style.cssText += `
       padding: ${isMobile ? '0px' : '10px'} !important;
       width: ${isMobile ? '90vw' : '100%'} !important;
        max-width: 600px !important;
        margin: 0 auto !important;
        background: transparent !important;
        border: none !important;
      `;
    }

    // UTM WhatsApp
    const utmField = shadow.querySelector('#custom\\#utm_whatsapp');
    if (utmField) {
      utmField.value = utmValue;
      utmField.dispatchEvent(new Event("input", { bubbles: true }));
      utmField.dispatchEvent(new Event("change", { bubbles: true }));
      
      const utmWrapper = utmField.closest('[data-testid="form-field-wrapper"]');
      if (utmWrapper) {
        utmWrapper.style.cssText = "display: none !important; visibility: hidden !important; height: 0 !important; margin: 0 !important; padding: 0 !important;";
      }
      
      utmField.style.cssText = "display: none !important; visibility: hidden !important;";
      
      const utmLabel = shadow.querySelector('label[for*="utm_whatsapp"]');
      if (utmLabel) {
        utmLabel.style.cssText = "display: none !important; visibility: hidden !important;";
      }
      
      console.log("✅ [WHATSAPP MULTI] UTM WhatsApp aplicado:", utmValue);
    }

    // Ocultar campos desnecessários
    const fieldsToHide = [
      '#custom\\#utm',
      '#custom\\#local_do_casamento'
    ];

    fieldsToHide.forEach(selector => {
      const field = shadow.querySelector(selector);
      if (field) {
        const wrapper = field.closest('[data-testid="form-field-wrapper"]');
        if (wrapper) {
          wrapper.style.cssText = "display: none !important; visibility: hidden !important; height: 0 !important; margin: 0 !important; padding: 0 !important;";
        }
        field.style.cssText = "display: none !important; visibility: hidden !important;";
      }
    });

    // Ocultar data de casamento
    const dataField = shadow.querySelector('input[aria-labelledby*="label-DD"]');
    if (dataField) {
      const dataWrapper = dataField.closest('[data-testid="form-field-wrapper"]');
      if (dataWrapper) {
        dataWrapper.style.cssText = "display: none !important; visibility: hidden !important; height: 0 !important; margin: 0 !important; padding: 0 !important;";
      }
    }

    // Botão
    const submitBtn = shadow.querySelector('[data-testid="btn-form-submit"]');
    if (submitBtn) {
      submitBtn.style.cssText += `
        width: 100% !important;
        background-color: #000 !important;
        color: #fff !important;
        border: none !important;
        padding: 16px 0 !important;
        border-radius: 8px !important;
        cursor: pointer !important;
        font-weight: 500 !important;
        font-size: 1.5rem !important;
        text-transform: uppercase !important;
        letter-spacing: 1px !important;
        transition: all 0.3s !important;
        margin-top: 10px !important;
        font-family: 'Montserrat', sans-serif !important;
      `;

      submitBtn.addEventListener('mouseenter', () => {
        submitBtn.style.transform = "translateY(-2px)";
      });

      submitBtn.addEventListener('mouseleave', () => {
        submitBtn.style.transform = "translateY(0)";
      });

      submitBtn.addEventListener("click", () => {
        setTimeout(() => {
          const nome = shadow.querySelector('#first_name')?.value || '';
          const email = shadow.querySelector('#email')?.value || '';
          const whatsapp = shadow.querySelector('#phone_number')?.value || '';

          console.log("🚀 [WHATSAPP MULTI] FORMULÁRIO ENVIADO!");
          console.log("   📝 Nome:", nome);
          console.log("   📧 Email:", email);
          console.log("   📱 WhatsApp:", whatsapp);
          console.log("   🏷️ UTM WhatsApp:", utmValue);
          console.log("   📦 Container:", containerId);
          console.log("   📍 Página:", window.location.pathname);

          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            'event': 'lead_whatsapp_submit',
            'form_id': FORM_ID,
            'page_url': window.location.href,
            'container_id': containerId,
            'form_data': {
              'nome': nome,
              'email': email,
              'whatsapp': whatsapp,
              'utm_campaign_whatsapp': utmValue
            }
          });

          setTimeout(() => closeModal(), 2000);
        }, 100);
      });
    }

    processedForms.add(form);
    console.log("✅ [WHATSAPP MULTI] Formulário configurado!");
    return true;
  }

  // ==========================================
  // 🔍 PROCESSAR TODOS OS FORMULÁRIOS
  // ==========================================
  function processAllForms() {
    let formsProcessed = 0;

    CONTAINER_IDS.forEach(containerId => {
      const container = document.querySelector(containerId);
      if (container && processWhatsappForm(container, containerId)) {
        formsProcessed++;
      }
    });

    if (formsProcessed > 0) {
      console.log(`✅ [WHATSAPP MULTI] ${formsProcessed} formulário(s) processado(s)`);
    }

    return formsProcessed > 0;
  }

  // ==========================================
  // 🔄 SISTEMA DE OBSERVAÇÃO
  // ==========================================
  function startObserver() {
    const observer = new MutationObserver(() => {
      processAllForms();
    });

    observer.observe(document.body, { 
      childList: true, 
      subtree: true 
    });

    console.log("✅ [WHATSAPP MULTI] Observer ativado");
  }

  // ==========================================
  // 🔄 DETECÇÃO DE NAVEGAÇÃO
  // ==========================================
  function setupNavigationListeners() {
    let lastUrl = location.href;
    
    new MutationObserver(() => {
      const url = location.href;
      if (url !== lastUrl) {
        lastUrl = url;
        console.log("🔄 [WHATSAPP MULTI] Navegação detectada:", url);
        
        setTimeout(() => processAllForms(), 500);
        setTimeout(() => processAllForms(), 1000);
      }
    }).observe(document, { subtree: true, childList: true });

    const originalPushState = history.pushState;
    const originalReplaceState = history.replaceState;

    history.pushState = function() {
      originalPushState.apply(this, arguments);
      console.log("🔄 [WHATSAPP MULTI] PushState detectado");
      setTimeout(() => processAllForms(), 500);
    };

    history.replaceState = function() {
      originalReplaceState.apply(this, arguments);
      setTimeout(() => processAllForms(), 500);
    };

    window.addEventListener('popstate', () => {
      console.log("🔄 [WHATSAPP MULTI] Popstate detectado");
      setTimeout(() => processAllForms(), 500);
    });

    console.log("✅ [WHATSAPP MULTI] Listeners de navegação ativados");
  }

  // ==========================================
  // 🚀 INICIALIZAÇÃO
  // ==========================================
  function init() {
    console.log("🟢 [WHATSAPP MULTI] Iniciando sistema...");
    console.log("📍 [WHATSAPP MULTI] Página inicial:", window.location.pathname);
    console.log("📦 [WHATSAPP MULTI] Monitorando", CONTAINER_IDS.length, "container(s):");
    CONTAINER_IDS.forEach((id, index) => {
      console.log(`   ${index + 1}. ${id}`);
    });
    
    createGlobalStyles();
    createFloatingButton();
    createModal();
    startObserver();
    setupNavigationListeners();
    
    processAllForms();
    setTimeout(() => processAllForms(), 500);
    setTimeout(() => processAllForms(), 1000);
    setTimeout(() => processAllForms(), 2000);
    
    console.log("✅ [WHATSAPP MULTI] Sistema totalmente ativo!");
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Funções de debug
  window.whatsappMultiDebug = {
    openModal,
    closeModal,
    processForm: processAllForms,
    checkContainers: () => {
      console.log("🔍 [DEBUG] Verificando containers:");
      CONTAINER_IDS.forEach((id, index) => {
        const exists = !!document.querySelector(id);
        console.log(`   ${index + 1}. ${id}: ${exists ? '✅ Encontrado' : '❌ Não encontrado'}`);
      });
    },
    addContainer: (newId) => {
      if (!CONTAINER_IDS.includes(newId)) {
        CONTAINER_IDS.push(newId);
        console.log("➕ [WHATSAPP MULTI] Novo container adicionado:", newId);
        createGlobalStyles(); // Recria os estilos
        processAllForms();
      } else {
        console.log("⚠️ [WHATSAPP MULTI] Container já existe na lista");
      }
    }
  };

  console.log("✅ [WHATSAPP MULTI] Script carregado com sucesso!");
  console.log("✅ [WHATSAPP MULTI] Sistema de UTM customizado ativo:", COOKIE_NAME_WHATSAPP);
})();